import {CMSContentType} from "./CMSType";

export const TYPE_HEADER_ONE = 'header-one';
export const TYPE_HEADER_TWO = 'header-two';
export const TYPE_HEADER_THREE = 'header-three';

export const TYPE_RICH_TEXT_CONTENT = 'rich-text-content';
export const TYPE_GALLERY_CONTENT = 'gallery-content';
export const TYPE_TRANSFERS_CONTENT = 'transfers-content';
export const TYPE_TWO_COLUMN_CONTENT = 'two-column-content';
export const TYPE_LIST_CONTENT = 'list-content';
export const TYPE_IMAGE_LIST_CONTENT = 'image-list-content';
export const TYPE_MAP_CONTENT = 'map-content';
export const TYPE_PLAYER_LIST_CONTENT = 'player-list-content';
export const TYPE_DETAILS_CONTENT = 'details-content';

let map = new Map<CMSContentType, string>();
map.set(CMSContentType.headerOne, TYPE_HEADER_ONE);
map.set(CMSContentType.headerTwo, TYPE_HEADER_TWO);
map.set(CMSContentType.list, TYPE_LIST_CONTENT);
map.set(CMSContentType.imageList, TYPE_IMAGE_LIST_CONTENT);
map.set(CMSContentType.map, TYPE_MAP_CONTENT);
map.set(CMSContentType.gallery, TYPE_GALLERY_CONTENT);
map.set(CMSContentType.richText, TYPE_RICH_TEXT_CONTENT);
map.set(CMSContentType.twoColumns, TYPE_TWO_COLUMN_CONTENT);
map.set(CMSContentType.transfers, TYPE_TRANSFERS_CONTENT);
map.set(CMSContentType.playerList, TYPE_PLAYER_LIST_CONTENT);
map.set(CMSContentType.details, TYPE_DETAILS_CONTENT);

export function cmsTypeToString(type: CMSContentType): string {
  return map.get(type);
}

export function cmsStringToType(val: string): CMSContentType {
  let res = null;
  map.forEach((value, index) => {
    if (value === val) res = index;
  });
  return res
}

export const DEFAULT_CLUB_HEADER_LABEL = 'Header title';
export const DEFAULT_CLUB_HEADER_TWO_LABEL = 'Title';




// WEBPACK FOOTER //
// ./src/api/club-cms/constants.ts